/**
 * Placeholder Screens
 * 
 * These screens are not yet fully designed.
 * They use the ScreenWrapper component for a basic layout.
 * Each will be replaced with high-fidelity implementations later.
 */
import React from 'react';
import { useOnboardingViewport } from '../shared/useViewport';

const ScreenWrapper = ({ title, subtitle, children }) => {
  const vp = useOnboardingViewport();
  const isDesktop = vp.isTablet;

  return (
    <div style={{ 
      textAlign: 'left', 
      marginTop: '20px',
      width: '100%',
      maxWidth: isDesktop ? '480px' : '100%',
      margin: isDesktop ? '0 auto' : undefined,
    }}>
      <h1 style={{ fontSize: '32px', fontWeight: '900', lineHeight: 1.1, marginBottom: '12px', letterSpacing: '-0.5px' }}>{title}</h1>
      {subtitle && <p style={{ fontSize: '18px', opacity: 0.7, marginBottom: '32px', fontWeight: '500', lineHeight: 1.5 }}>{subtitle}</p>}
      {children}
    </div>
  );
};

export const GoogleSignInScreen = ({ onGoogleSignIn }) => (
  <ScreenWrapper title="Save Your Progress" subtitle="Sync your learning across devices and never lose your streak.">
    <div style={{ marginTop: '40px' }}>
      <button
        onClick={onGoogleSignIn}
        style={{
          width: '100%',
          height: '56px',
          borderRadius: '16px',
          background: 'transparent',
          color: '#14B8A6',
          border: '2px solid #14B8A6',
          fontSize: '16px',
          fontWeight: '700',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px'
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24">
          <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
          <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
          <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
          <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
        </svg>
        Continue with Google
      </button>
    </div>
  </ScreenWrapper>
);

export const CommitmentScreen = () => (
  <ScreenWrapper title="Choose Your Pace" subtitle="How much time can you commit each day to your verbal growth?" />
);

export const LoadingAnalysisScreen = () => (
  <ScreenWrapper title="Creating Your Plan" subtitle="Analyzing your goals and current level to build the perfect curriculum..." />
);

export const FutureProjectionScreen = () => (
  <ScreenWrapper title="Your Future Self" subtitle="Based on your commitment, here is where you'll be in 6 months." />
);

export const PaywallScreen = () => (
  <ScreenWrapper title="Unlock Your Potential" subtitle="Get unlimited access to all games, personalized plans, and detailed progress tracking." />
);
